import BaseModel from './BaseModel';

class SecurityAmountDisplay extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
    this.errors = {}
  }

  updateData = (data) => {
    this.id = data.id;
    this.amount = data.amount || "";
    this.display_value = data.display_value || "";
  }

  toApiJson = () => {
    return {
      id: this.id,
      security_amount_display: {
        amount: this.amount,
        display_value: this.display_value,
      }
    }
  }

  set_api_errors = (errors) => {
    for (let field in errors) {
      this.errors[field] = errors[field]
    }
  }
  validations = (field) => {
    return {
      amount: () => {
        if(this[field] === "") {
          this.errors.amount = "Amount must be a number"
        }
      },
      display_value: () => {
        if(this[field] === "") {
          this.errors.display_value = "Display Value cannot be empty"
        }
      }
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default SecurityAmountDisplay;
